import React from 'react';
import { Calendar, Clock, User, FileText, Edit, Trash2, X } from 'lucide-react';
import { gymModalHeader, gymModalPanel } from './gymPageTheme';

// Modal Azioni Appuntamento (Visualizza/Modifica/Cancella)
function AppointmentActionsModal({ isOpen, appointment, onClose, onEdit, onDelete, readOnly = false }) {
    if (!isOpen) return null;

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('it-IT', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const formatTime = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleTimeString('it-IT', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handleDelete = () => {
        if (window.confirm('Sei sicuro di voler cancellare questo appuntamento?')) {
            onDelete();
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className={`${gymModalPanel} max-w-md`}>
                <div className={gymModalHeader}>
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                        {String(appointment.title || '').replace(/^0+/, '').trim()}
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800 dark:text-white/70 dark:hover:text-white"
                        aria-label="Chiudi"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>
                <div className="p-6">
                    <div className="mb-6 space-y-2 text-sm text-gray-600 dark:text-white/75">
                        <div className="flex items-center gap-2">
                            <Calendar size={16} className="shrink-0 text-gray-500 dark:text-white/55" />
                            <span>{formatDate(appointment.start_datetime)}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Clock size={16} className="shrink-0 text-gray-500 dark:text-white/55" />
                            <span>
                                {formatTime(appointment.start_datetime)} - {formatTime(appointment.end_datetime)}
                            </span>
                        </div>
                        {appointment.client_name && (
                            <div className="flex items-center gap-2">
                                <User size={16} className="shrink-0 text-gray-500 dark:text-white/55" />
                                <span>{appointment.client_name}</span>
                            </div>
                        )}
                        {appointment.description && (
                            <div className="mt-3 flex items-start gap-2">
                                <FileText size={16} className="mt-0.5 shrink-0 text-gray-500 dark:text-white/55" />
                                <span className="text-gray-800 dark:text-white/85">{appointment.description}</span>
                            </div>
                        )}
                    </div>

                    <div className="mb-6">
                        <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${
                            appointment.event_type === 'training' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200' :
                            appointment.event_type === 'consultation' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200' :
                            appointment.event_type === 'evaluation' ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200' :
                            'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-white/90'
                        }`}>
                            {appointment.event_type === 'training' ? '🏋️ Allenamento' :
                             appointment.event_type === 'consultation' ? '💬 Consulenza' :
                             appointment.event_type === 'evaluation' ? '📊 Valutazione' :
                             '📝 Altro'}
                        </span>
                    </div>

                    <div className="flex flex-col gap-3">
                        {!readOnly && (
                            <>
                                <button
                                    type="button"
                                    onClick={onEdit}
                                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-purple-600 px-4 py-3 text-white transition-colors hover:bg-purple-700 dark:bg-indigo-600 dark:text-white dark:hover:brightness-110"
                                >
                                    <Edit size={18} />
                                    Modifica Appuntamento
                                </button>

                                <button
                                    type="button"
                                    onClick={handleDelete}
                                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-3 text-white transition-colors hover:bg-red-700"
                                >
                                    <Trash2 size={18} />
                                    Cancella Appuntamento
                                </button>
                            </>
                        )}

                        {readOnly && (
                            <div className="rounded-lg bg-gray-100 px-4 py-3 text-center text-sm text-gray-600 dark:bg-gray-800 dark:text-white/80">
                                Modalità sola lettura
                            </div>
                        )}

                        <button
                            type="button"
                            onClick={onClose}
                            className="w-full rounded-lg bg-gray-500 px-4 py-3 text-white transition-colors hover:bg-gray-600 dark:bg-gray-800 dark:hover:brightness-110"
                        >
                            Chiudi
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppointmentActionsModal;
